<div class="app-page-title">
  <div class="page-title-wrapper">
  <div class="page-title-heading">
  <div class="page-title-icon">
  <i class="pe-7s-phone icon-gradient bg-premium-dark"></i>
  </div>
  <div>Rôle & Permission
  <div class="page-title-subheading">Liste des profiles</div>
  </div>
  </div>
  <!--div class="page-title-actions">
    <button type="button" (click)="open(dialog)" class="btn btn-primary px-5 rounded-0">Créer un profil</button>
  </div-->

</div>
  </div>

<div>

    <div >
        <div  class="card mb-3" *ngFor="let r of data" >
            <div class="card-header d-flex justify-content-between">
              
             <h5> {{r.name}}</h5>

                <button *ngIf="buttonsPermission.add" class="btn btn-primary btn-sm" (click)="open(dialog,r)" >Ajouter un droit </button>
            </div>
        
            <div class="card-body" style="height: 50vh; overflow-y: scroll; overflow-x: hidden;">
              <div class="row">
                  <table class="table table-sm">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Permission</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let p of r.permissions; let i=index">
                        <td>{{i+1}}</td>
                        <td>{{p.name}}</td>
                        <td>
                          <span class="float-right text-danger hand" (click)="revoke(r.id,p.id)"><u>Retirer</u></span>

                        </td>
                      </tr>
                    </tbody>
                  </table>

               
               </div>
              </div>
        </div>

    </div>
</div>

  <ng-template #dialog  let-ref="dialogRef" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="store(addForm.value,ref)">
      <div class="modal-header">
            <h6 class="modal-title">Ajout de droit</h6>
            <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
      </div>
      <div class="modal-body">
          <div class="form-group">
            <ng-select class="" name="permissionsChosen" [multiple]="true" ngModel (change)="setChosen($event)">
              <ng-option *ngFor="let pl of permissionsList; let i=index" [value]="pl.id">{{pl.name}}</ng-option>
            </ng-select>
          </div>

          <!-- <fieldset>
            <legend>Fenêtre autorisé</legend>
            <div class="form-group" *ngIf="windiow!=undefined">
              <label for=""></label>
              <input type="text" class="form-control" name="windiowName" [(ngModel)]="windiow.name" readonly>
            </div>
          </fieldset>
          <fieldset>
            <legend>Action autorisée sur cette fenêtre pour l'utilisateur</legend>
            <div class="form-check" *ngFor="let p of permissionsChosen; let i=index">
              <label class="form-check-label me-5" for="flexCheckChecked">
                {{p.label}}
              </label>
              <i class="fa fa-check success"></i>
             <input class="form-check-input" type="checkbox" [value]="p.value" id="flexCheckChecked{{i}}" [checked]="p.value" [readonly]="true"> 
            </div>
          </fieldset> -->
          <div>
            <button type="submit" class="btn btn-outline-primary" [disabled]="addForm.invalid || loading">Sauvegarder <app-loading [isVisible]="loading"></app-loading> </button>
          </div>
        
      </div>
</form>
  </ng-template>